var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M0 0h640v480H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M241 0v480h160V0H241zM0 160v160h640V160H0z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M0 193v96h640v-96H0zM273 0v480h96V0h-96z"
})));
SvgUk.displayName = "SvgUk";
export { SvgUk as ReactComponent };
export default SvgUk;